import { ClientFlagsProvider, OnUpdateClientFlags } from '@sdk/session/ClientFlagsContext';
import useToast from '@sdk/common/toast/useToast';
import ToastComponent from '@sdk/common/toast/ToastComponent';
import { AuthProvider } from '@sdk/authentication/AuthContext';
import type { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { ChiliPiperBanner } from './ChiliPiperBanner';

type Props = {
  path: string;
  currentUser: AuthUserType;
  onUpdateClientFlags: OnUpdateClientFlags;
};
export const ChiliPiperBannerWithContext = ({ path, currentUser, onUpdateClientFlags }: Props) => {
  const { showErrorToast } = useToast();

  const onUpdateClientFlagsFailure = (error: string) => {
    showErrorToast(error);
  };

  if (!currentUser) return null;

  return (
    <ClientFlagsProvider
      onUpdateClientFlags={onUpdateClientFlags}
      onUpdateClientFlagsFailure={onUpdateClientFlagsFailure}>
      <AuthProvider currentUser={currentUser}>
        <ChiliPiperBanner path={path} />
        <ToastComponent />
      </AuthProvider>
    </ClientFlagsProvider>
  );
};
